jQuery(function ($) {

    let investorCookie = getCookie('hig_investor_access');
    if (!investorCookie) {
        // Cookie not set or expired
        $('#jurisdictional-disclosure').addClass('active').fadeIn();
    } else {
        $('#jurisdictional-disclosure').removeClass('active').hide();
    }

    if ($('#jurisdictional-disclosure').hasClass('active')) {
        $('body').addClass('scroll-hide');
    }

    
    $('#gate_submit').prop('disabled', true);
    $('#country').on('change', function () {
      let country = $(this).val();
      $('#gate_submit').prop('disabled', true);
      $('#investor_type').empty().append('<option value="">Select Investor Type</option>');

      $('#eligibility').hide();
      if (!country) return;
      $.ajax({
        url: localized_object.ajax_url,
        type: "POST",
        data: {
            action: "load_investor_types",
            country: country,
        },
        beforeSend: function () {
            if ($("#investor_type .loader-overlay").length === 0) {
                $("#investor_type").append("<div class='loader-overlay'><div class='spinner'></div></div>");
            }
        },
        success: function(data) {
            if (Array.isArray(data) && data.length > 0) {
                data.forEach(type => {
                    $('#investor_type').append(
                      `<option value="${type.id}">${type.label}</option>`
                    );
                });
            } else {
                
                
            }
        },
        complete: function() {
            $(".loader-overlay").remove();
        }
    });
    });

    $('#investor_type').on('change', function () {
        let investorType = $(this).val(); 
        let countryId    = $('#country').val();
    
        $('#eligibility').hide();
        $('#eligibility-note').html('');
    
        if (!investorType || !countryId) {
        return;
        }
    
        $.ajax({
        url: localized_object.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'get_eligibility_text',
            investor_type: investorType,
            country_id: countryId
        },
        success: function (response) {
    
            if (response.success) {
            $('#eligibility-note').html(response.data.text);
            $('#eligibility_page_link').val(response.data.page_link);
            $('#eligibility').slideDown();
            } else {
            $('#gate_submit').prop('disabled', false);
            $('#eligibility').hide();
            }
    
        }
        });
    
    });

    $('input[name="eligible"]').on('change', function () {
        $('#gate_submit').prop('disabled', false);
      });


      
    jQuery('#gate_submit').on('click', function (e) {
        e.preventDefault();
        let country = jQuery('#country').val();
        let country_name = $('#country option:selected').text();
        let investor_type = jQuery('#investor_type').val();
        let eligibility = jQuery('input[name="eligible"]:checked').val();
        let page_link = jQuery('#eligibility_page_link').val();
        console.log("investor_type: ",investor_type);

        jQuery('#popup-important-professional-invbestor').removeClass('active');

        if ($('#popup-important-professional-invbestor').hasClass('active')) {
            $('body').addClass('scroll-hide');
        }

        if (country == 'Others' || country == 'Other') {
            jQuery('#jurisdictional-disclosure').fadeOut();
            jQuery('#no-access-popup').fadeIn();
        }
        if (investor_type == 'other') {
            jQuery('#jurisdictional-disclosure').fadeOut();
            jQuery('#no-access-popup').fadeIn();
        }
        if(investor_type == 'non-professional-investors') {
            jQuery('#jurisdictional-disclosure').fadeOut();
            jQuery('#no-access-popup').fadeIn();
        }
        if(eligibility == 'yes' && (investor_type == 'professional-investors' || investor_type == 'sophisticated-investor' || investor_type == 'semi-professional-investor' || investor_type == 'qualified-investor' || investor_type == 'institutional-investor' || investor_type == 'permitted-retail-investor' || investor_type == 'permitted-client' || investor_type == 'institutional-or-accredited-investor' || investor_type == 'retail-investor')) {   

            $('body').addClass('scroll-hide');
            jQuery('#page_link').val(page_link);
            jQuery('#jurisdictional-disclosure').fadeOut();
            jQuery('#popup-important-professional-invbestor').fadeIn();
            jQuery('#popup-important-professional-invbestor').addClass('active');
            jQuery('#important_investor_type').val(investor_type);
            jQuery('#important_investor_location').val(country);
            jQuery('#important_investor_location_name').val(country_name);
            jQuery('#eligible_type').val('yes');
            $('#accept_terms').prop('disabled', true);

        }
        else if(country_name == 'Singapore' && investor_type == 'permitted-client'){

            jQuery('#jurisdictional-disclosure').fadeOut();
            jQuery('#no-access-popup').fadeIn();

        }
        
        else{
            jQuery('#jurisdictional-disclosure').fadeOut();
            jQuery('#no-access-popup').fadeIn();
        }
    });


    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/; SameSite=Lax";
      }

      function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    $('input[name="important_terms"]').on('change', function () {
        $('#accept_terms').prop('disabled', !this.checked);
      });
    

      $('#accept_terms').on('click', function () {
        $('body').removeClass('scroll-hide');

        var page_link = jQuery('#page_link').val();

        // Collect hidden values
        let payload = {
          investor_type: $('#important_investor_type').val(),
          investor_location: $('#important_investor_location_name').val(),
          eligible_type: $('#eligible_type').val(),
          accepted_at: new Date().toISOString(),
          version: 'v1'
        };
    
        // Encode as single cookie value
        let encoded = encodeURIComponent(JSON.stringify(payload));
    
        // Set ONE cookie
        setCookie('hig_investor_access', encoded, 150);
        if(page_link){
            window.location.href = page_link;
            return;
        }   
        location.reload();
        
      });
  });